import React from 'react'

import { ModelMenuSelectorComponent } from '@front/squirtle'

const AdminHeader = ({ hasMultiple, ids, selectedCompany, setSelectedCompany, ...rest }) => (
  <ModelMenuSelectorComponent
    model_name={'company'}
    labelKeys={['name']}
    selectKeys={['company_id']}
    config={{ ids }}
    value={selectedCompany}
    onChange={setSelectedCompany}
    sx={{
      borderColor: 'primary.main',
      borderBottom: 1,
      borderTop: 1,
      ...(!!hasMultiple ? { '&:hover': { bgcolor: 'primary.light' } } : {})
    }}
    selectProps={!hasMultiple ? { IconComponent: null } : undefined}
    getOptionIconProps={() => ({ icon: 'account_balance_outlined' })}
    getOptionProps={() => ({ _container: { justifyContent: 'center', p: 1, gap: 2 }, variant: 'h6' })}
    disableUnderline
    selectFirst
    clearInvalid
    {...rest}
  />
)


export default React.memo(AdminHeader)
